import { render } from "./Add.vue?vue&type=template&id=f0aea32c"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/superAdmin/ecole/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0aea32c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0aea32c', __exports__)) {
    console.log('reload')
    api.reload('f0aea32c', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=f0aea32c", () => {
    console.log('re-render')
    api.rerender('f0aea32c', render)
  })

}


export default __exports__